import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import RequireRole from "./components/auth/RequireRole";

/* ================= ADMIN ================= */
import AdminLayout from "./pages/AdminLayout";
import DraftsPage from "./pages/DraftsPage";
import Settings from "./pages/settings/Settings";

import DraftExecutionStatus from "./pages/DraftExecutionStatus";
import DraftGeneratedView from "./pages/DraftGeneratedView";
import DraftVersionsPage from "./pages/DraftVersionsPage";
import AllDrafts from "./pages/AllDrafts";

/* ================= USER ================= */
import UserLayout from "./pages/UserLayout";
import UserDraftStatus from "./pages/UserDraftStatus";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ================= AUTH ================= */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />


        {/* ================= ADMIN ================= */}
        <Route
          path="/admin/*"
          element={
            <RequireRole role="Admin">
              <AdminLayout />
            </RequireRole>
          }
        >
          <Route index element={<DraftsPage />} />
          <Route path="draft-status/:jobId" element={<DraftExecutionStatus />} />
          <Route path="draft-versions" element={<DraftVersionsPage />} />
          <Route path="generated-draft" element={<DraftGeneratedView />} />
		  <Route path="alldrafts" element={<AllDrafts />} />

          {/* ✅ SETTINGS WITH SIDEBAR */}
          <Route path="settings/*" element={<Settings />} />
        </Route>

        {/* ================= USER ================= */}
        <Route
          path="/user/*"
          element={
            <RequireRole role="User">
              <UserLayout />
            </RequireRole>
          }
        >
          <Route index element={<DraftsPage />} />
          <Route path="status" element={<UserDraftStatus />} />
		  <Route path="draft-status/:jobId" element={<DraftExecutionStatus />} />
          <Route path="draft-versions" element={<DraftVersionsPage />} />
          <Route path="generated-draft" element={<DraftGeneratedView />} />
		  <Route path="alldrafts" element={<AllDrafts />} />
        </Route>

        {/* ================= FALLBACK ================= */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
